<script>
import cssVars from 'css-vars-ponyfill';
import SpecialCard from './components/SpecialCard.svelte';
import {data} from './data/data.js';
import Disclaimer from './components/disclaimer.svelte'

  let hondaData = data.honda.hondaData;
  let mazdaData = data.mazda.mazdaData;
  let config = '';
  let storeId =''

  const bsbh = {
    '--primary-color': 'rgba(42, 94, 154, 1)',
    '--primary-color-lighter': 'rgba(42, 94, 154, .1)',
    '--secondary-color': 'rgb(0, 49, 77)',
    '--secondary-color-lightest': 'rgb(207, 233, 247)',
    '--accent-color': 'var(--primary-color)',
    '--danger-color': '#e42525',
    '--success-color': '#00a651',
    '--image-padding': '0 15% ',
    '--image-margin': '15% 0 0',
    '--image-height': '200px',
    '--border-radius': '10px',
    '--special-background': '#e6e6e6',
};
const mazda = {
    '--primary-color': 'rgba(25, 25, 25, 1)',
    '--primary-color-lighter': 'rgba(25, 25, 25, .1)',
    '--secondary-color': 'rgba(25, 25, 25, 1)',
    '--secondary-color-lightest': 'rgba(25, 25, 25, 1)',
    '--accent-color': 'var(--danger-color)',
    '--danger-color': '#2b2b2b',
    '--success-color': '#2b2b2b',
    '--image-padding': '0',
    '--image-height': '230px',
    '--image-margin': '5% 0 0',
    '--border-radius': '0px',
    '--special-background': 'none',
};

  function selectedData() {
    const account = window.location.hostname;
    switch(account) {
      case 'www.classichonda.com':
        config = bsbh;
        storeId = 'ch'
        return hondaData;
        break;
      case 'www.classicmazda.com':
        config = mazda;
        storeId = 'mazda'
        return mazdaData;
        break;
      case 'www.mazdalakeland.com':
        config = mazda;
        storeId = 'mazda'
        return mazdaData;
        break;
      default:
        config = mazda;
        storeId = 'mazda'
        return mazdaData;
    };
  }; 
  let models = selectedData();



  let modelFilters = [];
  let specialTypeFilters = [];
  

  let modelNames = [...new Set(models.map(m => {
  return m.model;
  }))];

  let specialTypes = ['Featured Lease Offer', 'TRUE Sign & Drive', 'Featured Finance Offer'];
  

  function addFilter (i, arrayFilter) {
    arrayFilter.push(i);
    filter();
  };

  function addSpecialFilter (i, arrayFilter) {
    arrayFilter.push(i);
    filterSpecialTypes();
  };



  // function filter(i) {
  //   models = data.filter(m => {
  //     return m.model == i
  //   });
  // };

  function filter() {
    models = models.filter(m => {
      return modelFilters.includes(m.model);
    });
  };

  function filterSpecialTypes(i) {
    let x = selectedData.filter(m => {
      specialTypeFilters.includes();
    });

  };

  function clearFilters(filters) {
    filters.length = 0;
    models = selectedData;
  }; 

  function scrollTo(key) {
    document.getElementById(key).scrollIntoView({behavior: 'smooth'});
  };




cssVars({
  variables: config,
});


let activeDisclaimers = [];

function toggleDisclaimer(i) {
  console.log(activeDisclaimers)
  activeDisclaimers = activeDisclaimers.concat(i);
  console.log(activeDisclaimers);
};

function closeDisclaimer(i){
  activeDisclaimers = activeDisclaimers.slice(i)
}
</script>

<style>

*, :after, :before {
  box-sizing: border-box;
}

/* :root {
  --primary-color: rgba(42, 94, 154, 1);
  --primary-color-lighter: rgba(42, 94, 154, .1);
  --secondary-color: rgb(0, 49, 77);
  --secondary-color-lightest: rgb(207, 233, 247); 
  --danger-color: #e42525;
  --success-color: #00a651;
  --image-padding: 0;
  --image-height: auto;
  --border-radius: 10px;
} */

  .btn {
    padding: 8px 16px;
    border: 2px solid var(--primary-color);
    cursor: pointer;
    border-radius: var(--border-radius);
    font-weight: bold;
  }
  .btn-outline {
    background: none;
    color: var(--primary-color);
  }
  .btn-outline:hover {
    background: var(--primary-color-lighter);
  }
  .btn-danger {
    background: var(--danger-color);
    border: 2px solid var(--danger-color);
    color: white;
  }
  .btn-danger:hover {
    background: none;
    color: var(--danger-color);
  }

  .model-nav-container {
    margin: 16px auto;
  }

  .model-list {
    display: flex;
    flex-direction: row;
    list-style-type: none!important;
    padding: 0!important;
    flex-wrap: wrap;
    justify-content: center;
  }

  .model-navigation {
    list-style-type: none!important;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 0 auto 16px;
    padding: 0!important;
    max-width: 1400px;
  }
  .model-navigation li {
    margin: 0 8px 8px;
  }

  .model-navigation button {
    width: 100%;
  }
  
  .model-container {
    margin: 20px auto;
    max-width: 1600px;
  }


  .model-wrapper {
    max-width: 400px;
    min-width: 280px;
    margin: 0 16px 50px;
    box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%);
    border-radius: var(--border-radius);
    position: relative;
  }

/* Ribbon */
.ribbon {
	background-color: var(--success-color);
  color: white;
  font-weight: bold;
  font-size: 14px;
	margin-bottom: 10px;
	margin-top: 0;
	padding: 4.5px 16px;
	position: absolute;
  top: 16px;
	left: -15px;
	text-align: center;
  border-radius: 0 2px 2px 0;
  box-shadow: 1px 2px 4px rgba(0,0,0,0.3);
  text-transform: uppercase;
}

.ribbon:before{
	background-color: var(--success-color);
	content: "";
	display: block;
	height: 100%;
	position: absolute;
  top: 7.5px;
	width: 15px;
	filter: brightness(.5);
	z-index: -1;
}

.ribbon:before {
	left: 0;
	transform: skewy(45deg);
}

/* End Ribbon */

   .model-image {
     min-height: var(--image-height);
     padding: var(--image-padding);
     border-radius: 6px 6px 0 0;
     display: flex;
     align-items: center;
     position: relative;
     z-index: 1;
     text-align: center;
   }
   .model-image img {
     width: 100%;
     height: auto;
     overflow: hidden;
    margin: var(--image-margin)
   }


   .model-content {
     /* max-width: 320px; */
     padding: 10px 24px 0;
     overflow: hidden;
     text-align: center;
   }
   .model-title h2 {
     margin: 0 auto;
     margin-bottom: 6px;
     font-size: 16px;
     text-transform: uppercase;
   }
   .model-title p {
     margin: 0 auto;
     font-size: 14px;
   }
   .model-features {
     font-weight: bold;
     font-size: 12px;
     list-style-type: none!important;
     padding: 0!important;
     display: flex;
     flex-direction: row;
     flex-wrap: nowrap;
     justify-content: flex-start;
     overflow-x: auto;
     --webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
   }
   .model-features::-webkit-scrollbar {
     display: none;
   }

   .feature-list-item {
      background-color: var(--secondary-color);
      color: rgb(207, 233, 247);
      border-radius: 20px;
      padding: 4px 10px;
      margin: 0 2.5px 8px;
      white-space: nowrap;

   }
   .model-special-container {
     display: flex;
     flex-wrap: wrap;
     justify-content: center;
   }

   .model-ctas {
     margin: 0 auto 1rem;
   }


    @media only screen and (max-width: 800px) {
    .model-navigation {
      /* flex-direction: column; */
      justify-content: space-around;
    }
   }
   .model-ctas {
     margin: 0 auto 1.5rem;

   }
   .model-ctas a {
     text-decoration: none!important;
     margin: 8px auto 18px;
     border-radius: var(--border-radius);
     padding: 10px 32px;
     font-weight: bold;
     text-transform: uppercase;
     font-size: 16px;
     text-align: center;
     display: block;
     max-width: 250px;
   }

  .main-cta {
    background: var(--primary-color);
    color: white;
    box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12);
  }
  .main-cta:hover {
    background: var(--secondary-color);
    border-color: var(--secondary-color);
    box-shadow: none;
  }
  /* a.secondary-cta {
    color: var(--secondary-color);
  }
  a.secondary-cta:hover {
    text-decoration: underline!important;
  } */

  @keyframes card {
    0% {
        transform: perspective(1600px) rotateX(0deg) rotateY(0deg) translateZ(0px);
    }
    16% {
        transform: perspective(1600px) rotateX(-5deg) rotateY(-15deg) translateZ(32px);
    }
    100% {
        transform: perspective(1600px) rotateX(0deg) rotateY(0deg) translateZ(65px);
    }
  }
   @keyframes car {
    0% {
        transform: perspective(1600px) rotateX(0deg) rotateY(0deg) translateZ(0px);
    }
    100% {
        transform: perspective(1600px) rotateX(0deg) rotateY(0deg) translateZ(65px);
    }
  }

  hr.separator {
    border: 0;
    height: 1px;
    background: #ccc;
    width: 60%;
    margin: 10px 0;
  }

  .disclaimer {
    margin: 1rem auto 1.5rem;
    text-align: center;
  }

  .disclaimer-link {
     border: none!important;
     background: none!important;
     color: gray;
     cursor: pointer;
     font-size: 14px;
   }
   .disclaimer-link:hover {
     text-decoration: underline;
   }

   input[type=checkbox].checkbox{
   position: absolute;
   top: -9999px;
   left: -9999px;
  }

  .model-navigation input[type=checkbox]:checked ~ .checkbox-btn {
    background: var(--primary-color);
    color: white;
  }

</style>

<!-- <div class="model-nav-container">
  <ul class="model-navigation">
  {#each specialTypes as special}
    <li><input class="checkbox" type="checkbox" id={special} ><label for={special} class="btn btn-outline checkbox-btn" on:click={() => addSpecialFilter(special, specialTypeFilters)}>{special}</label></li>
  {/each}
  </ul>
</div>
<div class="model-nav-container">

  <ul class="model-navigation">
  {#each modelNames as model}
    <li><button for={model} class="btn btn-outline" on:click={() => addFilter(model, modelFilters)}>{model}</button></li>
  {/each}
    {#if modelFilters.length > 0 }<li><button class="btn btn-danger" on:click={() => clearFilters(modelFilters)}>Reset</button></li>{/if}
  </ul>
</div> -->
<div class="model-container">
  <ul class="model-list">

    {#each models as {title, year, make, model, trim, bodyStyle, image, subTitle, url, special, features, key, is_active, transmission, drivetrain}}
    {#if is_active === true}
    <li class="model-wrapper" id={key} >
      <div class="model-image">
        <div class="ribbon">{year} {#if !model.match('Mazda3|Mazda6')}{make} {/if}{model}</div>
          <a href="{url}">
            <img src={image} alt={title}>
          </a>
      </div>
        <div class="model-content">
          <div class="model-title">
            <!-- <h2>{trim} {transmission} {drivetrain}</h2> -->
            <!-- <h2>{title}</h2> -->
            <h2>{year} {#if !model.match('Mazda3|Mazda6')}{make} {/if}{model}</h2>
            <p style="font-weight: bold; color: #6B7280; text-transform: uppercase">{trim} {transmission} {drivetrain} {subTitle}</p>
            <!-- <p>{subTitle}</p> -->
          </div>
          {#if features}
          <ul class="model-features">
            {#each features as feature}
            <li class="feature-list-item">{feature}</li>
            {/each}
          </ul>
          {/if}
        </div>
      <div class="model-special-container">
      {#each special as special}
        {#if config === mazda}<hr class="separator">{/if}
        <SpecialCard {...special}/>
      {/each}
      </div>
      <div class="model-ctas">
      <a href="#form-cta" class="btn main-cta">Claim Offer</a>
      <a href={url} class="btn btn-outline">Shop Inventory</a>
      </div>
      <div class="disclaimer"><button class="disclaimer-link" on:click={() => toggleDisclaimer(key)}>Offer Details +</button></div>
      {#if activeDisclaimers.includes(key)}
      <Disclaimer closeDisclaimer={closeDisclaimer} key={key} disclaimers={special} storeId={storeId} />
      {/if}
    </li>
    {/if}
    {/each}
  </ul>
</div>